// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/report-templates/:id',
    requestBody: null,
    response: '{"success":true,"data":{...}}'
  },
  {
    method: 'GET',
    endpoint: '/api/print/data/:templateId?entitaType=commessa&entitaId=N&vista=APPALTATORE|ACQUIRENTE&conTotali=false&conAllegati=false',
    requestBody: null,
    response: '{"success":true,"data":{...,"_meta":{...}}}'
  },
  {
    method: 'GET',
    endpoint: '/api/smtp?tipo=EMAIL',
    requestBody: null,
    response: '{"smtp":[...]}'
  },
  {
    method: 'GET',
    endpoint: '/api/smtp?tipo=PEC',
    requestBody: null,
    response: '{"smtp":[...]}'
  },
  {
    method: 'GET',
    endpoint: '/api/report-templates/importa/societa',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","nome":"string","numTemplate":"number"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/report-templates/importa/templates?sorgenteId=',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","nome":"string","moduloGestionale":"string","attivo":"boolean","dimensioneHbs":"number"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/report-templates/importa/contenuto/:templateId',
    requestBody: null,
    response: '{"success":true,"data":{"contenutoHbs":"string","datiCampione":"string","cssOverride":"string"}}'
  },
  {
    method: 'PUT',
    endpoint: '/api/report-templates/:id',
    requestBody: '{"nome":"string","contenutoHbs":"string","datiCampione":"string",...}',
    response: '{"success":true}'
  },
  {
    method: 'POST',
    endpoint: '/api/print/email/:templateId',
    requestBody: '{"entitaType":"string","entitaId":"number","destinatari":["string"],"vista":"string?","conTotali":"boolean?","conAllegati":"boolean?"}',
    response: '{"success":true}'
  },
  {
    method: 'POST',
    endpoint: '/api/print/email-from-html',
    requestBody: '{"html":"string","destinatari":["string"],"oggetto":"string","smtpId":"number","ccn":["string"]}',
    response: '{"success":true}'
  },
  {
    method: 'POST',
    endpoint: '/api/print/pdf/:templateId',
    requestBody: '{"entitaType":"string","entitaId":"number","vista":"string?","conTotali":"boolean?","conAllegati":"boolean?"}',
    response: 'stream PDF'
  },
  {
    method: 'POST',
    endpoint: '/api/print/pdf-from-html',
    requestBody: '{"html":"string"}',
    response: 'stream PDF'
  },
  {
    method: 'POST',
    endpoint: '/api/print/pdf/:templateId',
    requestBody: '{"entitaType":"string","entitaId":"number","vista":"string?","conTotali":"boolean?","conAllegati":"boolean?"}',
    response: 'stream PDF'
  },
  {
    method: 'POST',
    endpoint: '/api/impostazioni/ai/editor-assist',
    requestBody: '{"societaId":"number","tipo":"struttura|dati","prompt":"string","contenutoAttuale":"string"}',
    response: '{"success":true,"data":{"contenuto":"string"}}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
